module.exports = __webpack_public_path__ + "static/media/mt.fd857604.svg";